import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../App.css';
import Dashheader from '../Dash-header/Dashheader';
import Sidebar from '../dashboard/Sidebar';
import './caseSummary.css';
import { END_URL, IMG_URL } from "../../config.js";
import CaseImg from '../../images/casesummart.svg';
import UsrRole from '../../images/userrole.svg';
import ComImg from '../../images/communication.svg';
import UserFooter from '../footer/UserFooter.jsx';

function CaseSummary() {
    const [expanded1, setExpanded] = useState(false);
    const [legalContent, setLegalContent] = useState(null);

    useEffect(() => {
        const fetchLegalContent = async () => {
            try {
                const response = await axios.get(`${END_URL}legal-page`);
                setLegalContent(response.data.data);
            } catch (error) {
                console.error('Failed to fetch legal content:', error);
            }
        };

        fetchLegalContent();
    }, []);

    return (
        <div className="dashboard-container full-width summary">
            <Dashheader />
            <div className="container">
                <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>
                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                        <div className="dashboard-side-div">
                            <Sidebar />
                            <a href="#" className="expand-btn" onClick={(e) => {
                                e.preventDefault();
                                setExpanded(!expanded1);
                            }}><span></span></a>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                        <main className="content">
                            <div className="form-container">

                                {legalContent?.legalcontent1 && (
                                    <div className="dashbord-first" dangerouslySetInnerHTML={{ __html: legalContent.legalcontent1 }} />
                                )}

                                <div className="row summ-subrow">
                                    <div className="col-md-8">
                                        {/* {legalContent?.legalcontent2 && (
                                            <div className="card-box">
                                                <div className="card-img">
                                                    <img src={CaseImg} alt="case_icon" />
                                                </div>
                                                <div className="card-content" dangerouslySetInnerHTML={{ __html: legalContent.legalcontent2 }} />
                                            </div>
                                        )} */}

                                        <div className="timeline-section">
                                            <h4>Legal Timeline</h4>
                                            <div className="timeline">
                                                {[1, 2, 3, 4, 5].map((i) => {
                                                    const title = legalContent?.[`title${i}`];
                                                    const image = legalContent?.[`image${i}`];
                                                    const status = legalContent?.[`status${i === 1 ? "" : i}`];
                                                    const dropdown = legalContent?.[`dropdown${i}`];  // Access dropdown field

                                                    if (!title || !image) return null;

                                                    return (
                                                        <div key={i} className={`timeline-item ${status === '1' ? 'active-status' : ''}`}>
                                                            <img src={`${IMG_URL}/public/${image}`} alt={`Timeline ${i}`} />
                                                            <span>{title}</span>
                                                            <div className="dropdown-status">
                                                                {dropdown}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                        <div className="content-card">
                                            <h4>Case Progress</h4>
                                            <div className="card-progress">
                                                {[2, 3, 4, 5, 6].map((num) => {
                                                    const progressHTML = legalContent?.[`caseprogress${num}`];
                                                    if (!progressHTML) return null;
                                                    return (
                                                        <div key={num} className="progress-item" dangerouslySetInnerHTML={{ __html: progressHTML }} />
                                                    );
                                                })}
                                            </div>
                                        </div>


                                    </div>

                                    <div className="col-md-4">
                                        {/* {legalContent?.legalcontent3 && (
                                            <div className="card-box">
                                                
                                                <div className="card-content" dangerouslySetInnerHTML={{ __html: legalContent.legalcontent3 }} />
                                            </div>
                                        )} */}

                                        {/* <div className="case-grid">
                                            {legalContent?.legalcontent5 && (
                                                <div className="card-box gray-box" dangerouslySetInnerHTML={{ __html: legalContent.legalcontent5 }} />
                                            )}
                                        </div> */}



                                        {legalContent?.legalcontent3 && (
                                            <div className="next-milestone">
                                                <h4>{legalContent.description2}</h4>




                                                <div className="card-content" dangerouslySetInnerHTML={{ __html: legalContent.legalcontent3 }} />
                                            </div>
                                        )}





                                        {legalContent?.legalcontent5 && (
                                            <div className="next-milestone">
                                                <h4>{legalContent.description3}</h4>
                                                <div className="card-img">
                                                    <span role="img" aria-label="calendar">🎯</span>
                                                </div>
                                                <div className="card-content" dangerouslySetInnerHTML={{ __html: legalContent.legalcontent5 }} />
                                            </div>
                                        )}





                                        {legalContent?.caseprogress7 && (
                                            <div className="next-milestone">
                                                <h4>{legalContent.description1}</h4>
                                                <div className="card-img">
                                                    <span role="img" aria-label="calendar">🗓️</span>
                                                </div>
                                                <div className="card-content" dangerouslySetInnerHTML={{ __html: legalContent.caseprogress7 }} />
                                            </div>
                                        )}
                                    </div>
                                </div>



                            </div>
                            <UserFooter />
                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CaseSummary;
